import { getTitle, getName, DATASETS } from '../Constants';
import { searchContext } from '../../context/Context';
import { useState } from 'react';
import SideBarContent from '../QueriedContent/SideBarContent';
import { useNavigate, useLocation } from 'react-router-dom';
import updateParams from '../../utils/updateParams';

export default function RenderInfoLogic({ searchItems, selectedInfoItem, setSearchItems, isMapping }) {
  const { setSelectedInfoItem, view } = searchContext();
  const navigate = useNavigate();
  const location = useLocation();

  const foundTitles = Array.isArray(searchItems) ? searchItems.map(item => getTitle(item)) : [];
  const ids = Array.isArray(searchItems) ? searchItems.map(item => getName(item)) : [];
  const [showModalExample, setShowModalExample] = useState(false);

  const handleOpenModal = item => {
    setSelectedInfoItem(item);
    setTimeout(() => setShowModalExample(true), 0);
  };

  const handleClearAndCloseInfoDiv = (index: number) => {
    const searchParams = new URLSearchParams(location.search);
    const currentIdents = searchParams.get('idents')?.split('-') || [];
    
    const newIdents = currentIdents.filter((_, i) => i !== index);
    
    if (newIdents.length === 0) {
      navigate('/');
    } else {
      const view = searchParams.get('view');
      const source = searchParams.get('source');
      const tab = searchParams.get('tab');
      
      const remainingSearchItems = searchItems.filter((_, i) => i !== index);
      
      const newParams = updateParams({
        searchItems: remainingSearchItems,
        view: view as string | undefined,
        source: source as string | undefined,
        tab: tab as string | undefined,
      });
      
      navigate({ pathname: location.pathname, search: newParams });
    }
  };

  return (
    <>
      {foundTitles.length > 0 && ids.length > 0 && (
        <div className="col-8 titCab">
          {foundTitles.length > 0 &&
            ids.length > 0 &&
            foundTitles.map((result, index) => (
              <div key={ids[index]}>
                <h4 className="titTabla d-flex">
                  {ids[index] && <span className="mr-2">{[result, ids[index]].join(', ')}</span>}
                  {result.title !== DATASETS.ALL && !isMapping && (
                    <div className="d-flex align-items-center">
                      <div className="mr-2">
                        <button
                          data-testid="open-info-button"
                          onClick={() => handleOpenModal(searchItems[index])}
                        >
                          <i className="bi-info-circle" />
                        </button>
                      </div>
                      <div>
                        <button
                          data-testid="close-info-button"
                          onClick={() => handleClearAndCloseInfoDiv(index)}
                        >
                          <i className="bi-x-circle"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </h4>
              </div>
            ))}
        </div>
      )}
      <div className="col-6 titTabla"></div>
      <SideBarContent
        selectedInfoItem={selectedInfoItem}
        view={view}
        showModalExample={showModalExample}
        setShowModalExample={setShowModalExample}
      />
    </>
  );
}
